/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BillingCentre/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function BillingCentre({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/Content/Content/Profile/InsurancePaymentAccount/Content/Content/BillingCentre"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let insuredInsuranceSubscriptionInsurancePlanInsuranceBillingCenterNameValueData = fromData.useDataValue({ viewPath,
context: 'insured',
path: 'insurance_subscription.insurance_plan.insurance_billing_center.name',
})
  return (<React.Fragment
>
<div
  data-testid="BillingCentre.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Billing Centre"
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="insured.insurance_subscription.insurance_plan.insurance_billing_center.name"
 text={insuredInsuranceSubscriptionInsurancePlanInsuranceBillingCenterNameValueData}
/>
</div>
{children}
</React.Fragment>)
}